// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"77":"d39f15f5","81":"a09badfa","245":"d079caf5","453":"20359781","588":"921da8bf","834":"f2de8840","929":"31246e88"}[chunkId] + ".chunk.js";
};